import { SET_ESRI_SUGGESTIONS, CLEAR_ESRI_SUGGESTIONS, SET_ESRI_FIELDS, CLEAR_ESRI_FIELDS } from "../actions/esriActions";

const initialState = {
  esriSuggestions: [],
  esriFields: [],
}

function esriReducer(state = initialState, action) {
  switch (action.type) {
  case SET_ESRI_SUGGESTIONS:
    return {
      ...state,
      esriSuggestions: action.payload
    }
  case CLEAR_ESRI_SUGGESTIONS:
    return {
      ...state,
      esriSuggestions: []
    }
  case SET_ESRI_FIELDS:
    return {
      ...state,
      esriFields: action.payload
    }
  case CLEAR_ESRI_FIELDS:
    return {
      ...state,
      esriFields: []
    }
  default:
    return state;
  }
}

export default esriReducer;